export type { RatingProps } from '../../types/rating';
export { Rating } from './adapters/inbound/Rating';
